import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { getPageRes } from "../loaders/page";
import '../styles/form.css';
import { DeleteComponent } from "./Delete/delete";

export default function DeletePage() {
    const params = useParams();
    const entryUrl = params.page ? `/${params.page}` : "/delete";
    const history = useNavigate();
    const [entry, setEntry] = useState({});
    const [error, setError] = useState(false);

    async function fetchData() {
        try {
            const result = await getPageRes(entryUrl, [], []);
            !result && setError(true);
            setEntry({ ...result });
        } catch (error) {
            setError(true);
            console.error(error);
        }
    }

    useEffect(() => {
        fetchData();
        error && history("/404");
    }, [entryUrl, error]);


    return Object.keys(entry).length ? (
        <DeleteComponent deletePageData={entry.page_components[0].delete} id={params.id} />
    ) : (
        <Skeleton count={5} height={400} />
    );
}
